(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@fiverr/globals"));
	else if(typeof define === 'function' && define.amd)
		define(["@fiverr/globals"], factory);
	else if(typeof exports === 'object')
		exports["GigCards"] = factory(require("@fiverr/globals"));
	else
		root["GigCards"] = factory(root["@fiverr/globals"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_E4I8__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition